import { componentStyle } from '@/styling/util/component-style.ts';
import type { InputTextDesignTokens } from '@primeuix/themes/types/inputtext';

export const inputTextStyle = componentStyle<InputTextDesignTokens>({
    root: {
        disabledBackground: '{ color.inputTextDisabledBackground }',
    },
});
